import React from 'react';
import API from '../../../api'
import Budget from './selectBudget';
import Profiles from './selectProfiles';
import ProfilesSelected from './descriptionProfiles';
import SubmitInfo from './submitInfo';
import { BrowserRouter, Route, Link } from 'react-router-dom';
import Summary from './summary';

export default class Main extends React.Component {
  constructor( props ) {
    super( props );
    this.state = {
      positions: [],
      data: 404,
      props: this.props,
      loader: ''
    }
    this.range = {
      min: 0,
      max: 0
    }
    this.sendEmail = this.sendEmail.bind();
    this.updateList = this.updateList.bind();
    this.request = this.request.bind();
    this.rangeBudget = this.rangeBudget.bind();
  }

  componentDidMount(){
    API.getAllProfiles().then(data => {
      data.map( item => {
        item.selected = false;
        item.profiles.map( profile => {
          profile.selected = false;
          profile.quantity = 1;
        })
      })
      this.setState({positions: data});
    })
  }

  rangeBudget = (min, max) => {
    this.range.min = min;
    this.range.max = max
  }

  request = () => {
    let list = this.state.positions;

    // Category Selected
    list.map( category => {
      list = list.filter( e => e.selected == true);
    })

    // Category-Profile Selected
    list.map( category => {
      category.profiles = category.profiles.filter( e => e.selected == true);
    }) 

    return list;
  }

  updateList = (list) => {
    this.setState({positions: list}, () => {
      console.log(list)
    })
  }

  sendEmail = (personal) => {
    let self = this;
    let method = "post";
    let url = "//app2soft.com/v1/sendmail.php";
    let request = this.request();
    let data = JSON.stringify({
      email: personal.email,
      firstName: personal.firstName,
      lastName: personal.lastName,
      profiles: request,
      minRange: this.range.min,
      maxRange: this.range.max
    })

    this.setState({ loader: 'loader' });

    API.sendEmail(url, data, method).then((res) => {
      setTimeout( () => {
        self.props.complete();
      }, 1000)
    }).catch( error => {
      self.props.complete();
    })
  }

  render() {
    return (
      <section className={`build-team-page ${this.state.loader}`}>
        <div className="single-column">
          <h2>Build your Development Team</h2>
          <p>App2soft gives you the opportunity of estimating the hourly investment rate of your own dedicated nearshore software development team. Pick and send the general description profiles of a team you would like to have and we’ll send you back a full description of each profile.
          </p>
          <div className="row">
            <div className="column-1">
            </div>
            <div className="column-1">
              <Budget
                key='step1'
                content={this.state.positions} 
                profiles={this.updateList}/>
              <Profiles
                key='step2'
                content={this.state.positions}
                profiles={this.updateList} />
              <ProfilesSelected
                key='step3'
                content={this.state.positions} 
                profiles={this.updateList} />
              <Summary 
                key='step4'
                content={this.state.positions}
                rangeBudget={this.rangeBudget} />
              <SubmitInfo 
                key='step5'
                content={this.state.positions}
                submitEmail={this.sendEmail} />
            </div>
          </div>
        </div>
      </section>            
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/build-your-team/views/main.js